import React from 'react'
import classNames from 'classnames'
import s from './GeoentityBlockRating.less'
import SVGIcon from '../../svg/SVGIcon'
import { checkBlockAspectFitsWhitelist } from './GeoentityBlockUtils'

export default function GeoentityBlockRating({ data }) {
  if (!checkBlockAspectFitsWhitelist(['star_max'], data)) return null

  const { max, rate } = data
  const numberRange = Array.from({ length: max }, (_, index) => index + 1)

  return (
    <div className={s.StarMax}>
      {numberRange.map(r => (
        <SVGIcon key={r} icon={'star'} className={classNames(s.icon, r <= rate ? s.iconFull : s.iconEmpty)} />
      ))}
    </div>
  )
}
